import { takeLatest, call, put } from 'redux-saga/effects';

import { fetchPostSuccess, fetchPostFailure } from './posts.actions';

import PostsActionTypes from './posts.types';

// news / careers posts (edit src/assets/data/posts.json)
import postsData from '../../assets/data/posts.json';

const fetchPosts = () => postsData;

export function* fetchPostAsync() {
  try {
    const posts = yield call(fetchPosts);
    yield put(fetchPostSuccess(posts));
  } catch (error) {
    yield put(fetchPostFailure(error.message));
  }
}

export function* fetchPostsStart() {
  yield takeLatest(PostsActionTypes.FETCH_POSTS_START, fetchPostAsync);
}
